import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';
import './settings-li';

interface SettingsSectionAttrs {
  'help-text': string;
  'help-link-url': string;
  'help-link-text': string;
  'tooltip-max-width': string;
  title: string;
}

export class SettingsSection extends Component<unknown, SettingsSectionAttrs> {
  static get attrsSchema(): AttrsSchema<SettingsSectionAttrs> {
    return {
      ...super.attrsSchema,
      'help-text': {type: `string`, description: `Set to add a help tooltip next to the title.`},
      'help-link-url': {type: `string`, description: `URL for help link`},
      'help-link-text': {type: `string`, description: `Text for help link anchor tag`},
      'tooltip-max-width': {type: `string`, description: `Width of info tooltip`, default: `250px`},
      title: `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }
}

export const SettingsSectionEl = defineAndMakeJsxFactory(`mp-settings-section`, SettingsSection);
export const SettingsSectionReact = panel2react(`mp-settings-section`, SettingsSection);
